import { MenuInterface } from "./../components/types/MenuInterface";

export const menuList: MenuInterface[] = [
  { url: "/", label: "Home" },
  { url: "/sobre", label: "Sobre" },
  { url: "/planos", label: "Planos" },
];
